import request from "@/utils/request";
/**
 * 获取园区名录
 */
export const getBaseList = (params) => {
  return request({
    header: {
      "Content-Type": "application/json",
    },
    url: "appInterface/v1/baseList",
    method: "get",
    params,
  });
};
/**
 * 获取某园区详情
 */
export const getBaseDetail = (params) => {
  return request({
    header: {
      "Content-Type": "application/json",
    },
    url: "appInterface/v1/findbyBaseId",
    method: "get",
    params,
  });
};

/**
 * 获取产品证书
 */
export const getlist = (params) => {
  return request({
    header: {
      "Content-Type": "application/json",
    },
    url: "https://zxscg.com/cprzapi/cmController/public/list",
    method: "get",
    params,
  });
};
/**
 * 获取某园区种植计划
 */
export const getBasePlan = (params) => {
  return request({
    header: {
      "Content-Type": "application/json",
    },
    url: "appInterface/v1/findPlanbyNum",
    method: "get",
    params,
  });
};
/**
 * 获取跳转发布种植计划页面参数
 */
export const getZZJHParams = (params) => {
  return request({
    header: {
      "Content-Type": "application/json",
	  "HTTP_X_FORWARDED_FOR":"nsyouxian.com",
    },
    url: "auth/v1/ssoBeforeLogin",
    method: "get",
    params,
  });
};
